import React from "react";
import {MailIcon, LinkedinIcon, GithubIcon} from './Icons'

const Contact = () => (
  <section id="contact" className="bg-gray-900 py-16 md:py-24 text-white">
    <div className="max-w-xl mx-auto text-center px-4">
      <h2 className="text-4xl font-extrabold mb-4">Let's Connect</h2>
      <p className="text-gray-400 text-lg mb-8">
        I'm actively seeking opportunities in Software Development and Technical Program Management. I bring professional rigor and a deep understanding of scalable systems.
      </p>
      <div className="flex justify-center space-x-6">
        <a 
          href="mailto:anton.berisha01@gmail.com" 
          className="text-gray-300 hover:text-indigo-400 transition duration-150 transform hover:scale-110"
          aria-label="Email Anton Berisha"
        >
          <MailIcon size={32} />
        </a>
        <a 
          href="https://www.linkedin.com/in/aberisha/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-gray-300 hover:text-indigo-400 transition duration-150 transform hover:scale-110"
          aria-label="LinkedIn Profile"
        >
          <LinkedinIcon size={32} />
        </a>
        <a 
          href="https://github.com/ABearish" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-gray-300 hover:text-indigo-400 transition duration-150 transform hover:scale-110"
          aria-label="GitHub Profile"
        >
          <GithubIcon size={32} />
        </a>
      </div>
    </div>
  </section>
);

export default Contact